import React, { useState, useEffect } from "react";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import AlertIcon from "../../common/alertIcon/alertIcon";
import DateFormat from "../../common/dateFormat/DateFormat";

export function TabelaDemandasMedidas(props) {
    const [visualizadoForaPonta, setVisualizadoForaPonta] = useState(props.item.consumoLeitura.status_visualizado_demanda_fora_ponta || false);
    useEffect(() => {
        setVisualizadoForaPonta(props.item.consumoLeitura.status_visualizado_demanda_fora_ponta || false);
    }, [props.item.consumoLeitura.status_visualizado_demanda_fora_ponta]);
    return (
        <table>
            <tbody>
                <tr title="Valor lido multiplicado pela constante do medidor">
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                        }}
                    >
                        Maior do Mês
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 100,
                        }}
                    >
                        {props.item.consumoLeitura.datahora_maior_demanda_mes ? (
                            <div>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.datahora_maior_demanda_mes)}</div>
                        ) : (
                            "-"
                        )}
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 60,
                            backgroundColor: props.item.consumoLeitura.cor_maior_demanda_mes,
                        }}
                    >
                        {adicionarPontosMilhar(props.item.consumoLeitura.maior_demanda_mes) || "-"}
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 80,
                        }}
                    >
                        {adicionarPontosMilhar(props.item.consumoLeitura.energia_total) || "-"}
                    </td>
                </tr>
                <tr title="Valor lido multiplicado pela constante do medidor">
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                        }}
                    >
                        Ponta
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 100,
                        }}
                    >
                        {props.item.consumoLeitura.datahora_demanda_ponta ? (
                            <div>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.datahora_demanda_ponta)}</div>
                        ) : (
                            "-"
                        )}
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 80,
                            backgroundColor: props.horosazonalAzul ? props.item.consumoLeitura.cor_demanda_ponta : null, //se for azul pinta, senao só deixa em negrito na cor definida
                            fontWeight: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_ponta ? "bold" : "normal",
                            color: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_ponta ? props.item.consumoLeitura.cor_demanda_ponta : null,
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {adicionarPontosMilhar(props.item.consumoLeitura.demanda_ponta) || "-"}{" "}
                            {props.item.consumoLeitura.cor_demanda_ponta === props.COR_ULTRAPASSAGEM && (
                                <div style={{ marginLeft: 5 }}>
                                    <AlertIcon
                                        width={20}
                                        height={20}
                                        animationClass={props.item.consumoLeitura.status_visualizado_demanda_ponta ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                        title="A demanda ponta ultrapassou a contratada"
                                        event={() => {
                                            if (window.confirm('A demanda ponta ultrapassou a contratada, deseja marcar alerta como "visualizado"?')) {
                                                props.setStatusVisualizado({
                                                    id: props.item.consumoLeitura.id,
                                                    coluna: "status_visualizado_demanda_ponta",
                                                });
                                                props.item.consumoLeitura.status_visualizado_demanda_ponta = true;
                                            }
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 80,
                        }}
                    >
                        {adicionarPontosMilhar(props.item.consumoLeitura.energia_ponta) || "-"}
                    </td>
                </tr>
                <tr title="Valor lido multiplicado pela constante do medidor">
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                        }}
                    >
                        Fora Ponta
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 100,
                        }}
                    >
                        {props.item.consumoLeitura.datahora_demanda_fora_ponta ? (
                            <div>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.datahora_demanda_fora_ponta)}</div>
                        ) : (
                            "-"
                        )}
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 80,
                            backgroundColor: props.horosazonalAzul ? props.item.consumoLeitura.cor_demanda_fora_ponta : null, //se for azul pinta, senao só deixa em negrito na cor definida
                            fontWeight: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_fora_ponta ? "bold" : "normal",
                            color: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_fora_ponta ? props.item.consumoLeitura.cor_demanda_fora_ponta : null,
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {adicionarPontosMilhar(props.item.consumoLeitura.demanda_fora_ponta) || "-"}
                            {props.item.consumoLeitura.cor_demanda_fora_ponta === props.COR_ULTRAPASSAGEM && (
                                <div style={{ marginLeft: 5 }}>
                                    <AlertIcon
                                        width={20}
                                        height={20}
                                        animationClass={visualizadoForaPonta ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                        title="A demanda fora ponta ultrapassou a contratada"
                                        event={() => {
                                            if (window.confirm('A demanda fora ponta ultrapassou a contratada, deseja marcar alerta como "visualizado"?')) {
                                                setVisualizadoForaPonta(true);
                                                props.setStatusVisualizado({
                                                    id: props.item.consumoLeitura.id,
                                                    coluna: "status_visualizado_demanda_fora_ponta",
                                                });
                                                // props.item.consumoLeitura.status_visualizado_demanda_fora_ponta = true;
                                            }
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </td>
                    <td
                        style={{
                            border: `1px solid ${props.corTabelaDemanda}`,
                            textAlign: "center",
                            padding: "2px 5px",
                            fontSize: "0.8rem",
                            textWrap: "nowrap",
                            minWidth: 80,
                        }}
                    >
                        {adicionarPontosMilhar(props.item.consumoLeitura.energia_fora_ponta) || "-"}
                    </td>
                </tr>
                {props.item.irrigante && (
                    <tr title="Valor lido multiplicado pela constante do medidor">
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                            }}
                        >
                            Reservado
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 100,
                            }}
                        >
                            {props.item.consumoLeitura.datahora_demanda_reservado ? (
                                <div>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.datahora_demanda_reservado)}</div>
                            ) : (
                                "-"
                            )}
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 80,
                                backgroundColor: props.horosazonalAzul ? props.item.consumoLeitura.cor_demanda_reservado : null, //se for azul pinta, senao só deixa em negrito na cor definida
                                fontWeight: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_reservado ? "bold" : "normal",
                                color: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_reservado ? props.item.consumoLeitura.cor_demanda_reservado : null,
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {adicionarPontosMilhar(props.item.consumoLeitura.demanda_reservado) || "-"}{" "}
                                {props.item.consumoLeitura.cor_demanda_reservado === props.COR_ULTRAPASSAGEM && (
                                    <div style={{ marginLeft: 5 }}>
                                        <AlertIcon
                                            width={20}
                                            height={20}
                                            animationClass={props.item.consumoLeitura.status_visualizado_demanda_reservado ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                            title="A demanda reservado ultrapassou a contratada"
                                            event={() => {
                                                if (window.confirm('A demanda reservado ultrapassou a contratada, deseja marcar alerta como "visualizado"?')) {
                                                    props.setStatusVisualizado({
                                                        id: props.item.consumoLeitura.id,
                                                        coluna: "status_visualizado_demanda_reservado",
                                                    });
                                                    props.item.consumoLeitura.status_visualizado_demanda_reservado = true;
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 80,
                            }}
                        >
                            {adicionarPontosMilhar(props.item.consumoLeitura.energia_reservado) || "-"}
                        </td>
                    </tr>
                )}
                {props.item.demanda_geracao_contratada_mes_atual && (
                    <tr title="Valor lido multiplicado pela constante do medidor">
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                            }}
                        >
                            Geração
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 100,
                            }}
                        >
                            {props.item.consumoLeitura.datahora_demanda_geracao ? (
                                <div>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.datahora_demanda_geracao)}</div>
                            ) : (
                                "-"
                            )}
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 80,
                                backgroundColor: props.horosazonalAzul ? props.item.consumoLeitura.cor_demanda_geracao : null, //se for azul pinta, senao só deixa em negrito na cor definida
                                fontWeight: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_geracao ? "bold" : "normal",
                                color: props.horosazonalVerde && props.item.consumoLeitura.cor_demanda_geracao ? props.item.consumoLeitura.cor_demanda_geracao : null,
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {adicionarPontosMilhar(props.item.consumoLeitura.demanda_geracao) || "-"}
                                {props.item.consumoLeitura.cor_demanda_geracao === props.COR_ULTRAPASSAGEM && (
                                    <div style={{ marginLeft: 5 }}>
                                        <AlertIcon
                                            width={20}
                                            height={20}
                                            animationClass={props.item.consumoLeitura.status_visualizado_demanda_geracao ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                            title="A demanda geração ultrapassou a contratada"
                                            event={() => {
                                                if (window.confirm('A demanda geração ultrapassou a contratada, deseja marcar alerta como "visualizado"?')) {
                                                    props.setStatusVisualizado({
                                                        id: props.item.consumoLeitura.id,
                                                        coluna: "status_visualizado_demanda_geracao",
                                                    });
                                                    props.item.consumoLeitura.status_visualizado_demanda_geracao = true;
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </td>
                        <td
                            style={{
                                border: `1px solid ${props.corTabelaDemanda}`,
                                textAlign: "center",
                                padding: "2px 5px",
                                fontSize: "0.8rem",
                                textWrap: "nowrap",
                                minWidth: 80,
                            }}
                        >
                            {adicionarPontosMilhar(props.item.consumoLeitura.energia_geracao) || "-"}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
